const resources = {
    showMore: 'Afficher plus de produits',
    breadcrumb: 'Breadcrumb',
    viewing: 'Viewing',
    results: 'results'
};

module.exports = function getResource(label) {
    return resources[label];
};
